'use client';

import Link from '@eliadmin/core/src/components/link';

import { Button } from '../ui/button';
import { useComparisonStore } from '../../stores/comparison-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { MdOutlineBalance } from 'react-icons/md';
import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function HeaderComparisionButton({ whiteText }: { whiteText: boolean }) {
  const isDesktop = useBreakpoint('md');
  const count = useComparisonStore(s => s.products.length);
  const { t } = useTranslations();

  return (
    <Button asChild variant={'none'} size={'none'} className="relative">
      <Link href={ROUTES.COMPARISON()} aria-label={t('text3746')}>
        <MdOutlineBalance
          aria-hidden
          size={isDesktop ? 20 : 24}
          className={cn(whiteText ? 'text-white' : 'text-black')}
        />
        {count > 0 && (
          <span className="absolute -right-2 -top-2 flex h-4 w-4 items-center justify-center rounded-full bg-secondary text-[10px] font-normal text-primary">
            {count}
          </span>
        )}
      </Link>
    </Button>
  );
}
